import { Box, Stack, Typography, useTheme } from "@mui/material";
import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";
import { CardRankingProps } from "./CardRanking.types";
import { CardRankingContainer } from "./CardRankingContainer";
import { LeaderboardClusterSelect } from "../../components/LeaderboardClusterSelect";
import { useCurrentLeaderboardCluster, useLeaderboardClusterStore } from "../../stores";
import { TitleTypography } from "../../styles/CommonWidgetStyles/Typography";
import { CommonWidgetContainer, InfoTooltip } from "../Commons/CommonWidgetContainer.styles";

export function CardRanking({
  isUserPage = false,
  enabled = true
}: CardRankingProps) {

  const theme = useTheme();
  const { t } = useTranslation();
  const leaderboardConfiguration = useLeaderboardClusterStore(state => ({ leaderboardAnonymous:state.currentCluster?.anonymize, leaderboard: !!state.currentCluster }));
  useCurrentLeaderboardCluster();

  if (!enabled) return null;

  return leaderboardConfiguration.leaderboard?(
    <CommonWidgetContainer component="section" aria-label={ t("card_ranking_widget_label") }  hasSidePadding={ false }>
      <Stack
        role={ "region" }
        aria-label={ t("your_ranking") }
        alignItems={ "center" }
        justifyContent={ "space-between" }
        direction={ "row" }
        gap={ 0 }
      >
        <TitleTypography>{ t("your_ranking") }</TitleTypography>
        {
          leaderboardConfiguration?.leaderboardAnonymous === true ? (
            <InfoTooltip
              arrow
              title={
                <Typography fontSize={ "0.85rem" }>
                  { t("anonymous_ranking") }
                </Typography>
              }
            >
              <Box sx={ {
                padding: "0rem 1rem"
              } }>
                <Info size={ 18 }/>
              </Box>
            </InfoTooltip>
          ) : null
        }
      </Stack>
      <LeaderboardClusterSelect
        sx={ {
          // maxWidth: "180px",
          marginX: theme.spacing(2),
          [`${theme.breakpoints.down("sm")}`]: {
            // maxWidth: "320px"
          },
          "&.MuiInputBase-root .MuiInputBase-input": {
            // paddingRight: 0
          }
        } } />
      <CardRankingContainer isUserPage={ isUserPage } enabled={ enabled } />
    </CommonWidgetContainer>
  ):null;
}


